import { createContext } from 'react';
import { IRestaurantDevices } from 'types';

export type TDevicesTabSortBy = '' | 'HardwareIdA-Z' | 'HardwareIdZ-A' | 'TerminalId1-10' | 'TerminalId10-1';
export type TDevicesTabCountOfItems = '12' | '24' | '48';

export interface IDevicesTabState {
	restaurantDevices: IRestaurantDevices;
	devicesTabSearchString: string;
	devicesTabSortBy: TDevicesTabSortBy;
	devicesTabCountOfItems: TDevicesTabCountOfItems;
	devicesTabCurrentPage: number;
}

export const devicesTabState: IDevicesTabState = {
	restaurantDevices: { count: 0, items: [] },
	devicesTabSearchString: '',
	devicesTabSortBy: '',
	devicesTabCountOfItems: '12',
	devicesTabCurrentPage: 1,
};

export interface IDevicesTabContext extends IDevicesTabState {
	changeDevicesTabSearchString(value: string): void;
	setDevicesTabSortBy(sortBy: TDevicesTabSortBy): void;
	setDevicesTabCountOfItems(count: TDevicesTabCountOfItems): void;
	changeDevicesTabCurrentPage(page: number): void;
}

export const DevicesTabContext = createContext<IDevicesTabContext>({
	changeDevicesTabSearchString: () => undefined,
	setDevicesTabSortBy: () => undefined,
	setDevicesTabCountOfItems: () => undefined,
	changeDevicesTabCurrentPage: () => undefined,
	...devicesTabState,
});
